import { message } from 'antd';
import React, { useState, useContext } from 'react';
import { changeUseAppointmentDesk } from 'api/ListingController';
import errorReporter from '@app/errorReporter';
import { SUPPORT_EMAIL } from 'utils';
import NewManageListingsContext from '../../Router/pages/AnsweringServicePage/ManageListings/ManageListingsContext';
import ManageListingsContext from '../../Router/pages/AppointmentDeskPage/ManageListings/ManageListingsContext';
import { Switch } from '../Switch';

const UseAppointmentDeskToggle: React.FC<{
  listingId: string;
  useAppointmentDesk: boolean;
  address: string;
}> = ({ listingId, useAppointmentDesk, address }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [checked, setIsChecked] = useState(useAppointmentDesk);
  const legacyContext = useContext(ManageListingsContext);
  const newContext = useContext(NewManageListingsContext);
  // TODO: Temporarily importing two ManageListingsContexts while we duplicate Answering Service pages over for the new flow.
  // Set this const without the conditional when the old ManageListingsContext page is removed.
  const setEnabledListingsCount =
    legacyContext?.setEnabledListingsCount ??
    newContext?.setEnabledListingsCount;

  const handleToggleChange = async (newChecked: boolean) => {
    try {
      setIsLoading(true);
      await changeUseAppointmentDesk(listingId, newChecked);
      message.success(
        <span data-cy="listing-enable-success">
          Answering service {newChecked ? 'enabled' : 'disabled'} for {address}
        </span>,
      );
      setIsChecked(newChecked);
      // TODO: This is only conditional while we use both the old and new ManageListingsContext.
      // Remove the if statement when we reduce it back down to only one ManageListingsContext file.
      // (e.g. when .../AppointmentDeskPage/ManageListings/ManageListingsContext is deleted.)
      if (setEnabledListingsCount) {
        setEnabledListingsCount(prev => prev + (newChecked ? 1 : -1));
      }
    } catch (err) {
      errorReporter.error('Error toggle useAppointmentDesk', err);
      message.error(
        <span data-cy="listing-enable-error">
          {`Answering service couldn’t be ${
            newChecked ? 'enabled' : 'disabled'
          } for ${address.trim()}. If this issue persists, contact `}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </span>,
      );
      setIsChecked(!newChecked);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Switch
      checked={checked}
      onChange={handleToggleChange}
      loading={isLoading}
      data-cy={`listing-enable-${listingId}`}
    />
  );
};

export default UseAppointmentDeskToggle;
